<script setup>
import { useI18n } from 'vue-i18n';
import PostSaleCasesTableTags from './PostSaleCasesTableTags.vue';
import {
  formatPostSaleDate,
  formatPostSaleTime,
  postSaleDeadlineClass,
} from './postSaleCasesTablePresenter';

defineProps({
  item: { type: Object, required: true },
});

const { t } = useI18n();
</script>

<template>
  <td class="p-3 align-top">
    <span
      class="rounded-full bg-lais-primary-50 px-2 py-1 text-xs font-semibold text-lais-primary"
    >
      {{ item.status_label || item.status }}
    </span>
    <p class="mt-2 text-xs text-lais-text-muted">
      {{
        formatPostSaleDate(item.table?.status_changed_at) ||
        t('POST_SALE.COMMON.NO_DATE')
      }}
    </p>
  </td>
  <td class="p-3 align-top">
    <span
      class="rounded-full border px-2 py-1 text-xs font-semibold"
      :class="postSaleDeadlineClass(item.deadline?.bucket)"
    >
      {{ item.deadline?.label || t('POST_SALE.DEADLINES.NO_DEADLINE') }}
    </span>
    <p class="mt-2 text-xs text-lais-text-muted">
      {{
        formatPostSaleDate(item.status_due_at) || t('POST_SALE.COMMON.NO_DATE')
      }}
    </p>
  </td>
  <td class="p-3 align-top">
    <p>
      {{ formatPostSaleDate(item.entered_at) || t('POST_SALE.COMMON.NO_DATE') }}
    </p>
    <span class="text-xs text-lais-text-muted">
      {{
        formatPostSaleTime(item.entered_at) || t('POST_SALE.COMMON.EMPTY_VALUE')
      }}
    </span>
  </td>
  <td class="p-3 align-top">
    <PostSaleCasesTableTags
      :items="item.table?.payment_methods"
      type="payments"
    />
  </td>
  <td class="p-3 align-top">
    <PostSaleCasesTableTags :items="item.table?.laudemiums" type="laudemiums" />
  </td>
  <td class="p-3 align-top">
    <span
      class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
    >
      {{ item.manager?.name || t('POST_SALE.COMMON.UNASSIGNED') }}
    </span>
  </td>
</template>
